export const JOBS_PANEL_VIEW_BREAKPOINT = 1240
